export enum CART_VISA {
  REJECT = "REJECT", //ปฏิเสธคำร้อง
  PENDING = "PENDING", //ส่งทบทวน
  CONFIRMED = "CONFIRMED", //เสร็จสิ้น
}
export const status_cart: {
  label: string;
  value: string;
}[] = [
  {
    label: "ไม่อนุมัติ",
    value: CART_VISA.REJECT,
  },
  {
    label: "รอตรวจสอบการชำระเงิน",
    value: CART_VISA.PENDING,
  },
  {
    label: "เสร็จสิ้น",
    value: CART_VISA.CONFIRMED,
  },

]
export const renderStatus = (value: string): string => {
  return (
    status_cart.find((x) => x.value === value)?.label ||
    status_cart.find((x) => x.value.split(",").includes(value))
      ?.label ||
    ""
  );
};


